export const uiRender = (arg) => {
    const { schema, rootElement, options } = arg;
    const measurementPoints = options.measurementPoints;
    // Set the root element styles
    rootElement.style.position = 'relative';
    rootElement.style.width = '100%';
    rootElement.style.height = '100%';
    rootElement.style.display = 'flex';
    rootElement.style.flexWrap = 'wrap';
    rootElement.style.justifyContent = 'flex-start';
    rootElement.style.alignItems = 'flex-start';
    rootElement.style.overflow = 'auto';
    const measurementPointID = Number(schema.appRender.measurementPoint);
    const measurementPoint = measurementPoints.find((point) => point.id === measurementPointID);
    if (measurementPoints.length === 0 || !measurementPoints) {
        const error = document.createElement('p');
        error.innerHTML = 'No measurement points available';
        rootElement.appendChild(error);
    }
    else if (!measurementPoint) {
        const error = document.createElement('p');
        error.innerHTML = 'No measurement point selected';
        error.style.flex = "1";
        error.style.textAlign = 'center';
        error.style.color = '#ff0000';
        error.style.fontSize = '16px';
        error.style.marginTop = '20px';
        rootElement.appendChild(error);
    }
    else {
        const table = document.createElement('table');
        table.style.flex = "1";
        table.style.width = "100%";
        const headers = ["Kontaktstelle", "Messung", "Fd [N]", "Td [ms]", "Fs [N]", "Fe [N]", "Bewertung"];
        const trHeader = document.createElement('tr');
        // Create header row
        headers.forEach(headerText => {
            const th = document.createElement('th');
            th.style.textAlign = "center";
            th.style.fontWeight = "bold";
            th.innerHTML = headerText;
            trHeader.appendChild(th);
        });
        table.appendChild(trHeader);
        // Create rows for measurements
        measurementPoint?.measurements.forEach((measurement, index) => {
            const row = [
                measurementPoint.label,
                measurement.label,
                "0", "0", "0", "0", "false"
            ];
            const tr = document.createElement('tr');
            tr.style.backgroundColor = index % 2 === 0 ? "#f2f2f2" : "#ffffff";
            row.forEach((cell) => {
                const td = document.createElement('td');
                td.innerHTML = cell;
                td.style.textAlign = "center";
                tr.appendChild(td);
            });
            table.appendChild(tr);
        });
        // Create empty row
        const createEmptyRow = () => {
            const tr = document.createElement('tr');
            headers.forEach(() => {
                const td = document.createElement('td');
                td.style.textAlign = "center";
                td.style.height = "20px"; // Höhe der leeren Zeile als Abstand
                td.innerHTML = ""; // Leere Zelle
                tr.appendChild(td);
            });
            return tr;
        };
        // Helper to create summary rows
        const createSummaryRow = (label) => {
            const tr = document.createElement('tr');
            tr.style.backgroundColor = label === "Mittelwert" ? "#f2f2f2" : "#ffffff";
            const filteredValues = [label, "", ...headers.slice(1, 6)];
            filteredValues.forEach((_, index) => {
                const td = document.createElement('td');
                if (index === 0) {
                    td.style.fontWeight = "bold";
                    td.innerHTML = label;
                    td.style.textAlign = "left";
                }
                else if (index > 1 && index < 6) {
                    td.innerHTML = "0";
                    td.style.textAlign = "center";
                }
                else {
                    td.innerHTML = "";
                }
                tr.appendChild(td);
            });
            return tr;
        };
        // Add average and max rows
        table.appendChild(createEmptyRow());
        table.appendChild(createSummaryRow("Mittelwert"));
        table.appendChild(createSummaryRow("Maximalwert"));
        rootElement.appendChild(table);
    }
};
//# sourceMappingURL=uiRender.js.map